import { Injectable } from '@angular/core';
import { HttpGeneralService } from '../../shared';
import { CONFIG } from '../../shared/config';
let infectionControlCategoryUrl = CONFIG.baseUrls.InfectionControlCategory;

export interface InfectionControlCategoryInterface {
  serial: number;
  descAr: string;
  descEn: string;
  sort?: number;
  isActive?: number;
  level?: number;
  parentSerial?: number;
  dataStatus: number
}
@Injectable({
  providedIn: 'root'
})
export class InfectionControlCategoriesService {

  constructor(private httpGeneralService: HttpGeneralService) { }
  // complaint classifications -------------------------------
  getInfectionControlCategoriesList(InfectionControlCategory: InfectionControlCategoryInterface) {
    return this.httpGeneralService.add(InfectionControlCategory, `${infectionControlCategoryUrl}/GetInfectionControlCategoriesList`);
  }

  addInfectionControlCategory(InfectionControlCategory: InfectionControlCategoryInterface[]) {
    return this.httpGeneralService.add(InfectionControlCategory, `${infectionControlCategoryUrl}/AddInfectionControlCategory`);
  }

  deleteInfectionControlCategory(serial: number) {
    return this.httpGeneralService.delete(serial, `${infectionControlCategoryUrl}/DeleteInfectionControlCategory`);
  }
}
